import api from 'api'
import { TerritorioMicroareaQueryInput } from 'graphql/types.generated'
import { defaultHandleError } from 'util/downloadFile'

export const downloadCsvAcompanhamentoTerritorio = (input: TerritorioMicroareaQueryInput) => {
  return api.acompanhamentoTerritorio.gerarCsvTerritorioMicroarea(input).catch(defaultHandleError)
}
